<template>
  <div id="app" >
    <meta name="referrer" content="no-referrer">
    <header style="position: absolute;z-index: 1000;width: 100%;" >
      <navHeader  ref=navHeader></navHeader>
    </header>
    <div  style="width:100%;height: 100px;background-color: #ffffff;"></div>
    <router-view/>
    <indexFooter ></indexFooter>
  </div>
</template>

<script>
import navHeader from '@/components/indexHeader'
import indexFooter from '@/components/indexFooter'
export default {
  name: 'App',
  components:{
    navHeader,
    indexFooter
  },
  
}
</script>
<style type="text/css">
  .el-carousel__container{
    height: 26.041666vw;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue